import React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { List } from "./List";
import { AddEdit } from "./AddEdit";
import { Ver } from "./Ver";

function MovimientosInventarios({ match }) {
    const { path } = match;

    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Route path={`${path}/add`} component={AddEdit} />
            <Route path={`${path}/ver/:id`} component={Ver} />     
            <Redirect from="*" to={{
                                pathname: List
                            }}/>
        </Switch>
    );
}

export { MovimientosInventarios };
